import script from "./LoadingOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingOverlay.vue?vue&type=script&setup=true&lang=js"

import "./LoadingOverlay.vue?vue&type=style&index=0&id=6be18f05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6be18f05"]])

export default __exports__